<template>
  <div class="feedbackbtn" @click="go_feedback">
    <img src="/static/img/ucenter/feedback.png" alt="">
  </div>
</template>

<script>
  export default {
    props: {
      isCheck: {
      type: Boolean,
      default:true
    },
  },
    methods: {
      go_feedback () {
        if(this.isCheck){
          try {
            this.hina.track('EV_FEEDBACK_CLICK')
            
          } catch (error) {
            
          }
        }
        this.$emit('fClick')
        this.$router.push('/ucenter_feedback')
      }
    }
  }
</script>

<style scoped lang="less">
.feedbackbtn {
  width: .8rem;
  height: 2.5rem;
  position: fixed;
  right: 0;
  bottom: 3rem;
  z-index: 1000;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
